module.exports = __webpack_public_path__ + "fonts/Quicksand-400-latin6.7b81366.woff2";